<script>
    import { createEventDispatcher } from 'svelte'
    import BigIcon from '../../components/Icons/BigIcon.svelte'
    import SearchQuery from '../../components/SearchQuery/SearchQuery.svelte'
    import SidepanelButton from '../../components/SidepanelLink/SidepanelButton.svelte'

    const dispatch = createEventDispatcher ();
</script>

<style>
    .SidepanelContent {
        padding: 25px 20px 20px 20px;
    }
    .SidepanelContent .icon-holder {
        text-align: center;
        margin-bottom: 10px;
    }
    .SidepanelContent .meta {
        text-align: center;
    }
    .SidepanelContent .meta .label {
        font-size: 18px;
        font-weight: 600;
    }
    .SidepanelContent .meta .text {
        font-size: 13px;
        color: var(--text-secondary);
        line-height: 14px;
    }
    .SidepanelContent .search, .SidepanelContent .links {
        margin-top: 10px;
    }
</style>

<div class="SidepanelContent">
    <div class="icon-holder">
        <BigIcon icon="fad fa-users" />
    </div>
    <div class="meta">
        <div class="label">Lista clienti</div>
        <div class="text">Seleziona un cliente dalla lista a destra</div>
    </div>
    <div class="links">
        <SidepanelButton on:click={() => dispatch ('create')}>
            Nuovo Cliente
        </SidepanelButton>
    </div>
    <div class="search">
        <SearchQuery on:search />
    </div>
</div>